<template>
  <div class="table-page">
    <header class="subpages-header">
      <router-link to="/map"
        ><button class="back-button">
          <md-icon class="md-size">keyboard_backspace</md-icon>Back to map
        </button></router-link
      >
      <h2 v-if="isIndiaTable">India</h2>
      <h2 v-else-if="isUnmappedStudiesTable">Unmapped Studies</h2>
      <h2 v-else-if="isNationalStudiesTable">National Studies</h2>
      <h2 v-else>{{ stateDisplayName }}</h2>
      <button id="download-csv" @click="exportTableToCSV('studies.csv')">
        Download CSV file
      </button>
    </header>
    <md-card class="table-page-card">
      <hei-studies-table :studies="spreadsheetData"></hei-studies-table>
    </md-card>
    <!-- <div class="relative-credits-container">
      <a href="http://zevross.com/" class="about-this-map-link"
        >Map application created by ZevRoss Spatial Analysis</a
      >
    </div> -->
  </div>
</template>

<script>
import HeiStudiesTable from "@/components/HeiStudiesTable.vue"; // @ is an alias to /src
import myMixin from "../mixins.js";

export default {
  name: "hei-table-page",
  props: ["state"],
  mixins: [myMixin],
  created: function() {
    this.fetchData().then(() => {
      this.filterData(this.$route.params.state);
    });
  },
  components: {
    HeiStudiesTable,
  },
  methods: {
    downloadCSV(csv, filename) {
      let csvFile;
      let downloadLink;

      // CSV file
      csvFile = new Blob([csv], { type: "text/csv" });

      // Download link
      downloadLink = document.createElement("a");

      // File name
      downloadLink.download = filename;

      // Create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);

      // Hide download link
      downloadLink.style.display = "none";

      // Add the link to DOM
      document.body.appendChild(downloadLink);

      // Click download link
      downloadLink.click();
    },
    exportTableToCSV(filename) {
      let csv = [];
      let rows = document.querySelectorAll(".studies-table tr");

      for (let i = 0; i < rows.length; i++) {
        let row = [],
          cols = rows[i].querySelectorAll("td, th");

        for (let j = 0; j < cols.length; j++)
          row.push('"' + cols[j].innerText + '"');

        csv.push(row.join(","));
      }
      csv.push("");
      csv.push(
        '"CAPHER-India. Spatial Bibliography 2021. capherindia@gmail.com"'
      );

      // Download CSV file
      this.downloadCSV(csv.join("\n"), filename);
    },
  },
  computed: {
    stateDisplayName: function() {
      return this.state;
    },
    isUnmappedStudiesTable() {
      return this.$route.params.state === "unmapped";
    },
    isNationalStudiesTable() {
      return this.$route.params.state === "national";
    },
    isIndiaTable() {
      return this.$route.params.state === "INDIA";
    },
  },
};
</script>

<style lang="scss">
.table-page {
  position: relative;
  .subpages-header {
    position: fixed;
    top: 0px;
    left: 0px;
  }
  .table-page-card {
    position: absolute;
    top: 50px;
  }
}

h2 {
  text-transform: capitalize;
}

body,
html {
  background-color: #fff !important;
}
.table-page-card {
  padding: 10px;
  background-color: #fff;
}

h3 {
  text-align: left;
}

.md-card {
  min-height: 0px;
}

.md-table {
  overflow: visible;
  max-width: 100vw !important;
  width: 100vw !important;
}

.md-table.md-theme-default .md-table-content,
.md-table.md-theme-default .md-table-alternate-header {
  height: auto !important;
  max-height: none !important;
  min-height: 100% !important;
  overflow-x: hidden !important;
}

@media only screen and (max-width: 500px) {
  .table-page {
    .table-page-card {
      top: 70px;
    }
  }
  .subpages-header {
    h2 {
      font-size: 14px;
    }
    button {
      font-size: 12px;
    }
  }
}

@media (pointer: coarse) {
  .md-table.md-theme-default .md-table-content,
  .md-table.md-theme-default .md-table-alternate-header {
    overflow-x: auto !important;
  }
}
</style>
